import * as Util from './util.js';

class Contact
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Contact
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //参照
    this.contact = $(".p-top__contact");
    this.btn = $(".p-top__contactBtn");
    this.container = $(".p-top__comtactFormContainer");
    this.wrapper = $(".p-top__comtactFormWrapper");

    //ボタンアクション
    this.btn.click((e)=>{
      e.preventDefault();

      if(this.contact.hasClass("open"))
      {
        this.close();
      }
      else
      {
        this.open();
      }
    });

    //タッチした時の処理
    this.btn.on("touchend", ()=>{
      this.btn.addClass("active");
      TweenMax.delayedCall(0.3, ()=>{
        this.btn.removeClass("active");
      });
    });

  }

  open(){

    //クラス追加
    this.contact.addClass("open");

    //フォームの高さ
    const formH = this.wrapper.outerHeight();

    //開く
    TweenMax.killTweensOf(this.container);
    TweenMax.to(this.container, 0.6, {"height":formH+"px", ease:Power2.easeInOut});
  }

  close(){

    //クラス削除
    this.contact.removeClass("open");

    //閉じる
    TweenMax.killTweensOf(this.container);
    TweenMax.to(this.container, 0.3, {"height":0});
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Contact;
